import { Article } from "../../../../icons";
import MobileNavTab from "./MobileNavTab";

export default function PublicationButton({ isActive }) {
	return (
		<MobileNavTab to="/publication_list/" label="مقالات" icon={Article} isActive={isActive} />
	);
}
